package one.healthium.ui.compose.components.adaptive

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxScope
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.ProvidableCompositionLocal
import androidx.compose.runtime.staticCompositionLocalOf
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clipToBounds
import androidx.compose.ui.graphics.Color

@Composable
fun TwoPaneLayout(
    modifier: Modifier = Modifier,
    containerColor: Color = MaterialTheme.colorScheme.surface,
    contentPadding: PaddingValues = PaddingValues.Zero,
    primaryPane: @Composable BoxScope.() -> Unit,
    secondaryPane: @Composable BoxScope.() -> Unit,
) {
    CompositionLocalProvider(
        IsTwoPane provides true
    ) {
        Row(
            modifier = modifier
                .fillMaxSize()
                .background(containerColor)
                .padding(contentPadding)
        ) {
            Box(
                modifier = Modifier.weight(1.4f).clipToBounds(),
                content = primaryPane,
            )
            Box(
                modifier = Modifier.weight(2f).clipToBounds(),
                content = secondaryPane,
            )
        }
    }
}

val IsTwoPane: ProvidableCompositionLocal<Boolean?> = staticCompositionLocalOf { null }

val ProvidableCompositionLocal<Boolean?>.currentOrDefault: Boolean
    @Composable
    get() = current ?: false